// PhonicsLt04.js
// 包装组件：Letter Teams L04
// 路由：/phonics/lt04
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt04 } from './phonics/phonics_data_lt04';

function PhonicsLt04() {
  return <PhonicsLt letterData={letterDataLt04} />;
}

export default PhonicsLt04;
